module.exports = __webpack_public_path__ + "img/fpx-logo.2306e250.png";